export interface Visibility {
    userIds: number[];
    groupIds: string[];
}

export function isVisible(
    visibility: Visibility,
    groupId: string,
    userId: number
): boolean {
    if (visibility.userIds.length === 0 && visibility.groupIds.length === 0) {
        return true;
    }

    if (
        visibility.userIds.length !== 0 &&
        visibility.userIds.includes(userId)
    ) {
        return true;
    }

    return (
        visibility.groupIds.length !== 0 &&
        visibility.groupIds.includes(groupId)
    );
}
